
import { onMounted, reactive, ref } from "vue";
import axios from "axios";
import { useRoute, useRouter } from 'vue-router';
export default {
     name:"AdminRaterangeCreate",
 setup() {
    const data  =reactive({
      start_range:'',
      end_range:'',
      range_price:'',
      riderrate_id:'',  
      rate_type:'Working Days',
      rate_price_type:'Relative'
    });
   
      const router = useRouter();
      const route = useRoute();
     const cities =ref([]);
 

    onMounted(async ()=>{
      
     if(route.params.id){
      data.riderrate_id = String(route.params.id);
      }
           
        
    });

const submit =async ()=>{

await axios.post(`/riderrateranges`,data);

  await router.push(`/riderrates/detail/${data.riderrate_id}`);
}


    return {
        data,
        
      submit
    };
  },
};
